import React from 'react'
import { object, array, string } from 'prop-types'
import { locations } from '../../../../../config/generatedConfig.js'

class GetCachedPriceAllLocations extends React.Component {
  // Tech debt #181
  getProduct () {
    const { pageData: { productClass } } = this.props
    switch (productClass.toUpperCase()) {
      case 'CP':
        return {
          path: 'parking/',
          type: 'CP',
          configKey: 'carParking'
        }
      case 'HCP':
        return {
          path: 'hotels/',
          type: 'HCP',
          configKey: 'hotels'
        }
      case 'HO':
        return {
          path: 'hotels/',
          type: 'HO',
          configKey: 'hotels'
        }
    }

    return false
  }

  getPriceFromFeed (product) {
    const { functionParams = [] } = this.props
    try {
      const { prices } = require('../../../../../config/exports/buildTimeOnly/prices/' + product.path + 'allLocations.json')
      const type = this.getPriceType()
      if (!type || !prices) return false
      if (functionParams[0].match(/location/) && locations[product.configKey].hasOwnProperty(prices[type])) {
        return locations[product.configKey][prices[type]]
      }
      return (prices[ type ]) ? prices[type] : false
    } catch (e) {
      return false
    }
  }

  getPriceType () {
    const { functionParams = [] } = this.props
    return functionParams[0] ? functionParams[0] : false
  }

  render () {
    const { id, settings: { decimalNotation, priceFormat } } = this.props
    const product = this.getProduct()
    const type = product ? this.getPriceType() : false
    let value = product ? this.getPriceFromFeed(product) : false
    if (value) value = parseFloat(value).toFixed(2).replace('.', decimalNotation)
    return (
      <span id={id} data-type={type} className='priceSmall'>{ product && value !== false && priceFormat + value }</span>
    )
  }
}

GetCachedPriceAllLocations.propTypes = {
  id: string.isRequired,
  settings: object,
  functionParams: array,
  pageData: object
}

export default GetCachedPriceAllLocations



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/pricing/getCachedPriceAllLocations.jsx